/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import fetchSiteReferrers from '../../action/site_referrer/fetchSiteReferrers'
import AccountTitleDetailAction from '../../action/account_title_detail'
import DailyClosingAction from '../../action/daily_closing'
import ReservationsStore from '../../store/reservation/ReservationsStore'
import DailyClosingDetailsStore from '../../store/daily_closing/DailyClosingDetailsStore'
import DailyClosingHeadStore from '../../store/daily_closing/DailyClosingHeadStore'
import SiteReferrerOptionsStore from '../../store/options/SiteReferrerOptionsStore'
import AccountTitleDetailOptionsStore from '../../store/options/AccountTitleDetailOptionsStore'
import EditViewStore from '../../store/daily_closing/EditViewStore'
import RoomOptionsStore from '../../store/options/RoomOptionsStore'
import DailyProcessEditView from '../../view/pages/daily_process/EditView'

class EditContainer extends Component {
  static getStores() {
    return [RoomOptionsStore, SiteReferrerOptionsStore, AccountTitleDetailOptionsStore, ReservationsStore, DailyClosingHeadStore, DailyClosingDetailsStore, EditViewStore]
  }

  static calculateState(prevState, props) {
    return {
      site_referrer_options: SiteReferrerOptionsStore.getState(),
      account_title_detail_options: AccountTitleDetailOptionsStore.getState(),
      head: DailyClosingHeadStore.getState(),
      details: DailyClosingDetailsStore.getState(),
      view: EditViewStore.getState(),
      ...props
    }
  }

  async componentDidMount() {
    await fetchSiteReferrers('closing')
    await AccountTitleDetailAction.fetchAccountTitleDetails()

    const dailyClosingHeadId = this.state.match.params.id
    await DailyClosingAction.fetchOne(dailyClosingHeadId)
  }

  isNew() {
    return this.state.match.params.id ? false : true
  }

  render() {
    return DailyProcessEditView(this.state, true)
  }
}

export default withRouter(Container.create(EditContainer, { withProps: true }))
